import React from "react";
import "./contactAvatar.scss";

// Letters only (names can carry emoji or punctuation), first + last initial.
export const contactInitials = (firstName, lastName, fallback) => {
  const letter = s => (String(s || "").match(/\p{L}/u) || [""])[0].toUpperCase();
  const fromParts = letter(firstName) + letter(lastName);
  if (fromParts) return fromParts;
  const words = String(fallback || "").split(/\s+/).filter(w => letter(w));
  return (letter(words[0]) + letter(words[1])) || "?";
};

// A contact's photo (a Salesgear image URL) when there is one, else their initials in a circle.
const ContactAvatar = ({ photo, firstName, lastName, name }) => {
  const [failed, setFailed] = React.useState(false);
  return (
    <span className="contactAvatar" aria-hidden="true">
      {photo && !failed ? (
        <img src={photo} alt="" loading="lazy" onError={() => setFailed(true)} />
      ) : (
        contactInitials(firstName, lastName, name)
      )}
    </span>
  );
};

export default ContactAvatar;
